import userReducer from '../reducers/User/user.reducer';
import { configureStore } from '@reduxjs/toolkit';

export default configureStore({
  reducer: {
    user: userReducer
  }
})